import companies from '@/modules/companies/store.js';
import dotp from '@/modules/donations-over-the-phone/store/dotp.js';
import exportsData from '@/modules/exports-data/store.js';
import pbiReportViewer from '@/modules/pbi-report-viewer/store.js';
import pbiReports from '@/modules/pbi-reports/store.js';
import roles from '@/modules/roles/store.js';
import securityGroups from '@/modules/security-groups/store.js';
import contacts from '@/modules/supporters/stores/contacts.js';
import supporters from '@/modules/supporters/stores/supporters.js';
import users from '@/modules/users/store.js';
import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import confirm from './modules/confirm';
import donationModal from './modules/donation-modal';
import eventLogs from './modules/event-logs';
import kickbox from './modules/kickbox';
import loading from './modules/loading';
import notifications from './modules/notifications';
import smsPayment from './modules/sms-payment';
import twilio from './modules/twilio';
import unsplash from './modules/unsplash';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    loading,
    donationModal,
    eventLogs,
    companies,
    confirm,
    users,
    roles,
    notifications,
    dotp,
    smsPayment,
    twilio,
    supporters,
    contacts,
    securityGroups,
    pbiReports,
    pbiReportViewer,
    unsplash,
    kickbox,
    exportsData,
  },
});
